import Lozenge from '@atlaskit/lozenge';
import React from 'react';
import RichTooltip from "../../../../primitives/RichTooltip";
import { LozengeList } from "./HeaderLozenges.styles";
export const HeaderLozengeItem = ({
  lozenge
}) => {
  const {
    label,
    isBold = false,
    appearance = 'default',
    tooltipContent = null
  } = lozenge;
  const lozengeContent = /*#__PURE__*/React.createElement(Lozenge, {
    appearance: appearance,
    isBold: isBold
  }, label);
  if (tooltipContent) {
    return /*#__PURE__*/React.createElement("li", {
      key: label
    }, /*#__PURE__*/React.createElement(RichTooltip, {
      content: tooltipContent
    }, lozengeContent));
  }
  return /*#__PURE__*/React.createElement("li", {
    key: label
  }, lozengeContent);
};
const HeaderLozenges = ({
  lozenges
}) => {
  if (!lozenges.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(LozengeList, null, lozenges.map(lozenge => /*#__PURE__*/React.createElement(HeaderLozengeItem, {
    key: lozenge.label,
    lozenge: lozenge
  })));
};
export default HeaderLozenges;